import { createAction, Action, ActionsUnion } from "../../Utils/actionHelpers";

export enum AlertActionKeys {
  SET_CLOSED = "[ALERRT] SET_CLOSED",
  SET_OPEN = "[ALERRT] SET_OPEN",
}

export const AlertActions = {
  setOpen: (title: string, message: string): SetOpenAlertAction =>
    createAction(AlertActionKeys.SET_OPEN, { title, message }),

  setClosed: (): SetClosedAlertAction =>
    createAction(AlertActionKeys.SET_CLOSED),
};

export type AlertActionUnion = ActionsUnion<typeof AlertActions>;

export type SetOpenAlertAction = Action<
  AlertActionKeys.SET_OPEN,
  {
    title: string;
    message: string;
  }
>;
export type SetClosedAlertAction = Action<AlertActionKeys.SET_CLOSED>;
